export default __webpack_public_path__ + "static/media/about.815e6260.svg";